// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_Ch_I9","avatar":"index_avatar_Gn6Cm"};